import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import {
  IQueryParams,
  createEntitySlice,
  EntityState,
  serializeAxiosError,
  BaseResponseEntities,
  IOption,
} from 'app/shared/reducers/reducer.utils';
import { apiOkr } from 'app/config/axios-interceptor';
import { defaultValue, ICategoryReport } from 'app/shared/model/category-report.model';

const initialState: EntityState<ICategoryReport> = {
  loading: false,
  errorMessage: null,
  entities: [],
  options: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/okr/category-report';

// Actions
interface IQueryParamsReportType extends IQueryParams {
  reportObjectType?: number;
  reportObjectId?: string;
}

export const getEntities = createAsyncThunk(
  'categoryReport/fetch_entity_list',
  async ({ searchText, page, size, sort, filters, reportObjectType, reportObjectId }: IQueryParamsReportType) => {
    return apiOkr.get<BaseResponseEntities<ICategoryReport>>(apiUrl, {
      params: {
        searchText,
        page,
        size,
        filters: filters && JSON.stringify(filters),
        sort: sort && sort,
        reportObjectType,
        reportObjectId,
        // cacheBuster: new Date().getTime(),
      },
    });
  },
  { serializeError: serializeAxiosError },
);

export const getSelectBox = createAsyncThunk(
  'categoryReport/fetch_entity_list_options',
  async (planPeriodId: string) => {
    return apiOkr.get<IOption[]>(`${apiUrl}/select-box/${planPeriodId}`);
  },
  { serializeError: serializeAxiosError },
);

export const createEntity = createAsyncThunk(
  'categoryReport/create_entity',
  async (entity: ICategoryReport, thunkAPI) => {
    const result = await apiOkr.post<ICategoryReport>(apiUrl, cleanEntity(entity));
    return result;
  },
  { serializeError: serializeAxiosError },
);
// slice

export const ReportTypeSlice = createEntitySlice({
  name: 'categoryReport',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntities), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          loading: false,
          entities: data.items,
          totalItems: data.totalRecord,
        };
      })
      .addMatcher(isFulfilled(getSelectBox), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          options: data,
        };
      })
      .addMatcher(isFulfilled(createEntity), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })

      .addMatcher(isFulfilled(createEntity), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })
      .addMatcher(isPending(getSelectBox), state => {
        state.options = [];
      })
      .addMatcher(isPending(getEntities), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isPending(createEntity), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = ReportTypeSlice.actions;

// Reducer
export default ReportTypeSlice.reducer;
